import LoggerService from '../service/logger.service';
import SDK from '@zoom/appssdk';
import {
  APP_CAPABILITIES,
  DIRECTORY_APP_CAPABILITIES,
  APP_DEVICE_TYPE,
  APP_POPOUT_SIZE,
  MAKEPHONECALL_SUCCESS,
  MAKEPHONECALL_FAILURE
} from '../constants/zoomApp.constants';
import { getMockClientDetails } from '../mock/zoomAppClient.mock';
import { parseUserAgent } from './commonHelper';
class ZoomAppClient {
  static IS_ZOOM_CLIENT_SUPPORTED = true;
  static ZOOM_APP_CONFIG_RESPONSE = null;
  static DEVICE_TYPE = null;

  static async configureApp(isDirectory) {
    try {
      const capabilities = isDirectory === true ? DIRECTORY_APP_CAPABILITIES : APP_CAPABILITIES;
      this.ZOOM_APP_CONFIG_RESPONSE = await SDK.config({
        popoutSize: APP_POPOUT_SIZE,
        capabilities: capabilities
      });
      this.DEVICE_TYPE = APP_DEVICE_TYPE[this.ZOOM_APP_CONFIG_RESPONSE.product];
      console.log('configureApp response', this.ZOOM_APP_CONFIG_RESPONSE);
    } catch (error) {
      console.log('configureApp error', error);
      this.IS_ZOOM_CLIENT_SUPPORTED = false;
    }
    return this.IS_ZOOM_CLIENT_SUPPORTED;
  }

  static async getClientDetails(isDirectory = false) {
    if (!this.IS_ZOOM_CLIENT_SUPPORTED) {
      return getMockClientDetails();
    }

    const clientDetails = {
      deviceType: this.DEVICE_TYPE
    };

    if (isDirectory === true) {
      return clientDetails;
    }
    const meetingContextResponse = (await SDK.getMeetingContext()) || null;
    const userContextResponse = (await SDK.getUserContext()) || null;
    const meetingJoinUrlResponse = (await SDK.getMeetingJoinUrl()) || null;
    const meetingUUIDResponse = (await SDK.getMeetingUUID()) || null;
    const browserOSINFO = parseUserAgent(this.ZOOM_APP_CONFIG_RESPONSE);
    return {
      meetingID: meetingContextResponse?.meetingID || null,
      meetingJoinUrl: meetingJoinUrlResponse?.joinUrl || null,
      meetingUUID: meetingUUIDResponse?.meetingUUID || null,
      userContext: userContextResponse || null,
      browserOSInfo: browserOSINFO,
      ...clientDetails
    };
  }

  static async openExternalUrl(externalUrl) {
    if (this.IS_ZOOM_CLIENT_SUPPORTED && this.DEVICE_TYPE) {
      await SDK.openUrl({ url: externalUrl });
    } else {
      window.open(externalUrl, '_blank');
    }
  }

  static async MakePhoneCall(number) {
    if (this.IS_ZOOM_CLIENT_SUPPORTED) {
      await SDK.makePhoneCall({ phoneNumber: number, callerId: '', autoDial: true });
    }
  }

  static prepareZoomPhoneCallParams(phoneNumber, options = {}) {
    const { phoneUserName = '', callerId = '', autoDial = true } = options;
    const phoneCallParams = {
      phoneNumber,
      phoneUserName,
      callerId,
      autoDial
    };
    return phoneCallParams;
  }

  static async initiatePhoneCallAndRespond(phoneCallParams) {
    if (!this.IS_ZOOM_CLIENT_SUPPORTED) {
      LoggerService.log('Zoom SDK: not supported');
      return false;
    }

    try {
      const makePhoneCallResponse = await SDK.makePhoneCall(phoneCallParams);
      LoggerService.log('Zoom SDK: MakePhoneCall response', makePhoneCallResponse);
      let statusMessage;
      if (typeof makePhoneCallResponse === 'string') {
        statusMessage = makePhoneCallResponse.trim();
      } else if (makePhoneCallResponse && typeof makePhoneCallResponse === 'object' && typeof makePhoneCallResponse.message === 'string') {
        statusMessage = makePhoneCallResponse.message.trim();
      } else {
        LoggerService.log('Zoom SDK: Invalid response', makePhoneCallResponse);
        return false;
      }
      if ([MAKEPHONECALL_SUCCESS, MAKEPHONECALL_FAILURE].includes(statusMessage)) {
        return statusMessage === MAKEPHONECALL_SUCCESS;
      }
      LoggerService.log('Zoom SDK: Unexpected message value:', statusMessage);
      return false;
    } catch (error) {
      LoggerService.log('Zoom SDK: Runtime exception initiating phone call:', error);
      return false;
    }
  }
}

export default ZoomAppClient;
